import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Tooltip,
  Button,
  Chip,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Typography,
  Paper,
  CircularProgress,
  Switch,
  FormControlLabel,
  Snackbar
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Search as SearchIcon,
  LocationOn as LocationIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Business as BusinessIcon,
  CheckCircle as ActiveIcon,
  Cancel as InactiveIcon,
  Home as HomeIcon,
  Refresh as RefreshIcon,
  Person as PersonIcon
} from '@mui/icons-material';
import api from '../services/auth';
import { getCurrentUser } from '../services/auth';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

const Succursale = () => {
  const [succursales, setSuccursales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedSuccursale, setSelectedSuccursale] = useState(null);
  const [dialogMode, setDialogMode] = useState('add');
  const [entreprises, setEntreprises] = useState([]);
  const [managers, setManagers] = useState([]);
  const [loadingManagers, setLoadingManagers] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  // Form state
  const [formData, setFormData] = useState({
    entreprise: '',
    nom: '',
    adresse: '',
    telephone: '',
    email: '',
    manager: '',
    is_active: true,
    is_main_branch: false,
    date_ouverture: format(new Date(), 'yyyy-MM-dd'),
    date_fermeture: ''
  });

  const [formErrors, setFormErrors] = useState({});

  // Récupérer l'utilisateur connecté au montage
  useEffect(() => {
    const user = getCurrentUser();
    console.log('Utilisateur connecté:', user);
    setCurrentUser(user);
    
    if (!user) {
      window.location.href = '/login';
      return;
    }
    
    fetchSuccursales();
    // fetchEntreprises();
    fetchManagers();
  }, []);

  const showSnackbar = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const fetchSuccursales = async () => {
    try {
      setLoading(true);
      const response = await api.get('/succursales/');
      
      let data = [];
      if (Array.isArray(response.data)) {
        data = response.data;
      } else if (response.data?.results) {
        data = response.data.results;
      } else if (response.data?.data) {
        data = response.data.data;
      }
      
      setSuccursales(data);
      setError('');
    } catch (err) {
      console.error('Erreur succursales:', err);
      let errorMsg = 'Erreur lors du chargement des succursales';
      
      if (err.response?.status === 401) {
        errorMsg = 'Session expirée, veuillez vous reconnecter';
      } else if (err.response?.status === 403) {
        errorMsg = 'Permission refusée';
      } else if (err.response?.data?.detail) {
        errorMsg = err.response.data.detail;
      }
      
      setError(errorMsg);
      setSuccursales([]);
    } finally {
      setLoading(false);
    }
  };

  // const fetchEntreprises = async () => {
  //   try {
  //     const response = await api.get('/entreprises/');
      
  //     let data = [];
  //     if (Array.isArray(response.data)) {
  //       data = response.data;
  //     } else if (response.data?.results) {
  //       data = response.data.results;
  //     } else if (response.data?.data) {
  //       data = response.data.data;
  //     }
      
  //     setEntreprises(data);
      
  //     // Si l'utilisateur n'est pas super_admin, pré-sélectionner son entreprise
  //     if (currentUser && currentUser.role !== 'super_admin' && currentUser.entreprise) {
  //       const userEntreprise = data.find(e => e.id === currentUser.entreprise);
  //       if (userEntreprise) {
  //         setFormData(prev => ({
  //           ...prev,
  //           entreprise: userEntreprise.id
  //         }));
  //       }
  //     }
  //   } catch (err) {
  //     console.error('Erreur entreprises:', err);
      
  //     if (currentUser?.entreprise) {
  //       setEntreprises([{
  //         id: currentUser.entreprise,
  //         nom: 'Mon entreprise',
  //         module_actif: currentUser.module_actif || 'depot'
  //       }]);
        
  //       setFormData(prev => ({
  //         ...prev,
  //         entreprise: currentUser.entreprise
  //       }));
  //     } else {
  //       setEntreprises([]);
  //     }
  //   }
  // };

  const fetchManagers = async () => {
    try {
      setLoadingManagers(true);
      console.log('Récupération des managers depuis /succursales/available_managers/');
      
      const response = await api.get('/succursales/available_managers/');
      console.log('Réponse managers:', response.data);
      
      let managersData = [];
      
      // Gestion flexible des différents formats de réponse
      if (Array.isArray(response.data)) {
        managersData = response.data;
      } else if (response.data && typeof response.data === 'object') {
        // Chercher dans les propriétés possibles
        const possibleKeys = ['results', 'data', 'managers', 'available_managers', 'users'];
        for (const key of possibleKeys) {
          if (Array.isArray(response.data[key])) {
            managersData = response.data[key];
            console.log(`Données trouvées dans la clé: ${key}`);
            break;
          }
        }
        
        // Si toujours pas de données, essayer d'extraire des valeurs de l'objet
        if (managersData.length === 0) {
          managersData = Object.values(response.data).filter(item => 
            item && typeof item === 'object' && (item.id || item.pk)
          );
        }
      }
      
      console.log(`Nombre de managers récupérés: ${managersData.length}`);
      
      // Formater les données
      const formattedManagers = managersData
        .map(manager => {
          // Vérifier si c'est un objet valide
          if (!manager || typeof manager !== 'object') return null;
          
          return {
            id: manager.id || manager.pk || manager.user_id,
            username: manager.username || manager.email || `Manager ${manager.id}`,
            first_name: manager.first_name || '',
            last_name: manager.last_name || '',
            email: manager.email || '',
            role: manager.role || 'manager',
            full_name: manager.first_name && manager.last_name 
              ? `${manager.first_name} ${manager.last_name}`
              : manager.username || 'Manager'
          };
        })
        .filter(manager => manager && manager.id); // Filtrer les entrées valides
      
      console.log('Managers formatés:', formattedManagers);
      setManagers(formattedManagers);
      
    } catch (err) {
      console.error('Erreur lors de la récupération des managers:', err);
      
      // Fallback: essayer /users/ si /available_managers/ échoue
      if (err.response?.status === 404 || err.response?.status === 500) {
        console.log('Endpoint spécifique échoué, tentative avec /users/');
        try {
          const fallbackResponse = await api.get('/users/');
          
          let fallbackUsers = [];
          if (Array.isArray(fallbackResponse.data)) {
            fallbackUsers = fallbackResponse.data;
          } else if (fallbackResponse.data?.results) {
            fallbackUsers = fallbackResponse.data.results;
          } else if (fallbackResponse.data?.data) {
            fallbackUsers = fallbackResponse.data.data;
          }
          
          // Filtrer seulement les managers, propriétaires et super_admins
          const filteredManagers = fallbackUsers.filter(user => 
            user && (user.role === 'manager' || user.role === 'proprietaire' || user.role === 'super_admin')
          );
          
          // Formater
          const formattedFallbackManagers = filteredManagers.map(user => ({
            id: user.id,
            username: user.username || user.email,
            first_name: user.first_name || '',
            last_name: user.last_name || '',
            email: user.email || '',
            role: user.role || 'user',
            full_name: user.first_name && user.last_name 
              ? `${user.first_name} ${user.last_name}`
              : user.username || 'Utilisateur'
          }));
          
          console.log('Managers fallback:', formattedFallbackManagers);
          setManagers(formattedFallbackManagers);
          
        } catch (fallbackErr) {
          console.error('Erreur fallback:', fallbackErr);
          setManagers([]);
        }
      } else {
        setManagers([]);
      }
    } finally {
      setLoadingManagers(false);
    }
  };

  useEffect(() => {
    if (currentUser) {
      // fetchEntreprises();
    }
  }, [currentUser]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handleOpenDialog = (mode, succursale = null) => {
    setDialogMode(mode);
    setSelectedSuccursale(succursale);
    setFormErrors({});
    
    if (mode === 'edit' || mode === 'view') {
      setFormData({
        entreprise: succursale.entreprise?.id || succursale.entreprise || '',
        nom: succursale.nom || '',
        adresse: succursale.adresse || '',
        telephone: succursale.telephone || '',
        email: succursale.email || '',
        manager: succursale.manager?.id || succursale.manager || '',
        is_active: succursale.is_active,
        is_main_branch: succursale.is_main_branch,
        date_ouverture: succursale.date_ouverture
          ? format(parseISO(succursale.date_ouverture), 'yyyy-MM-dd')
          : format(new Date(), 'yyyy-MM-dd'),
        date_fermeture: succursale.date_fermeture
          ? format(parseISO(succursale.date_fermeture), 'yyyy-MM-dd')
          : ''
      });
    } else {
      // Reset form for add mode
      const newFormData = {
        entreprise: '',
        nom: '',
        adresse: '',
        telephone: '',
        email: '',
        manager: '',
        is_active: true,
        is_main_branch: false,
        date_ouverture: format(new Date(), 'yyyy-MM-dd'),
        date_fermeture: ''
      };
      
      // Pré-sélectionner l'entreprise de l'utilisateur si ce n'est pas un super_admin
      if (currentUser && currentUser.role !== 'super_admin' && currentUser.entreprise) {
        newFormData.entreprise = currentUser.entreprise;
      }
      
      setFormData(newFormData);
    }
    
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedSuccursale(null);
    setFormErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData.entreprise) errors.entreprise = 'Entreprise requise';
    if (!formData.nom?.trim()) errors.nom = 'Nom requis';
    if (!formData.adresse?.trim()) errors.adresse = 'Adresse requise';
    if (!formData.date_ouverture) errors.date_ouverture = 'Date d\'ouverture requise';
    
    if (formData.telephone && !/^[\d\s\+\-\(\)]{8,20}$/.test(formData.telephone)) {
      errors.telephone = 'Numéro de téléphone invalide';
    }
    
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = 'Email invalide';
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      showSnackbar('Veuillez corriger les erreurs dans le formulaire', 'error');
      return;
    }
    
    setActionLoading(true);
    
    try {
      const dataToSend = {
        ...formData,
        manager: formData.manager || null
      };
      
      console.log('Données envoyées:', dataToSend);
      
      if (dialogMode === 'add') {
        const response = await api.post('/succursales/', dataToSend);
        console.log('Succursale créée:', response.data);
        showSnackbar('Succursale créée avec succès', 'success');
      } else if (dialogMode === 'edit') {
        const response = await api.put(`/succursales/${selectedSuccursale.id}/`, dataToSend);
        console.log('Succursale modifiée:', response.data);
        showSnackbar('Succursale modifiée avec succès', 'success');
      }
      
      await fetchSuccursales();
      handleCloseDialog();
      
    } catch (err) {
      console.error('Erreur enregistrement:', err);
      
      if (err.response?.status === 400) {
        const apiErrors = err.response.data;
        console.error('Erreurs de validation:', apiErrors);
        
        const formattedErrors = {};
        Object.keys(apiErrors).forEach(key => {
          if (Array.isArray(apiErrors[key])) {
            formattedErrors[key] = apiErrors[key].join(', ');
          } else {
            formattedErrors[key] = apiErrors[key];
          }
        });
        
        setFormErrors(formattedErrors);
        showSnackbar('Erreurs de validation, vérifiez le formulaire', 'error');
      } else if (err.response?.status === 403) {
        showSnackbar('Permission refusée', 'error');
      } else if (err.response?.status === 401) {
        showSnackbar('Session expirée', 'error');
      } else if (err.response?.status === 500) {
        showSnackbar('Erreur serveur, veuillez réessayer', 'error');
      } else {
        showSnackbar('Erreur lors de l\'enregistrement', 'error');
      }
    } finally {
      setActionLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette succursale ?')) return;
    
    setActionLoading(true);
    
    try {
      await api.delete(`/succursales/${id}/`);
      showSnackbar('Succursale supprimée avec succès', 'success');
      await fetchSuccursales();
      
    } catch (err) {
      console.error('Erreur suppression:', err);
      
      if (err.response?.status === 403) {
        showSnackbar('Permission refusée pour la suppression', 'error');
      } else if (err.response?.status === 400) {
        showSnackbar('Impossible de supprimer cette succursale', 'error');
      } else if (err.response?.status === 401) {
        showSnackbar('Session expirée', 'error');
      } else if (err.response?.status === 500) {
        showSnackbar('Erreur serveur lors de la suppression', 'error');
      } else {
        showSnackbar('Erreur lors de la suppression', 'error');
      }
    } finally {
      setActionLoading(false);
    }
  };

  const handleToggleStatus = async (id, currentStatus) => {
    setActionLoading(true);
    
    try {
      await api.patch(`/succursales/${id}/`, {
        is_active: !currentStatus
      });
      
      await fetchSuccursales();
      showSnackbar(`Succursale ${!currentStatus ? 'activée' : 'désactivée'} avec succès`, 'success');
      
    } catch (err) {
      console.error('Erreur changement statut:', err);
      
      if (err.response?.status === 401) {
        showSnackbar('Session expirée', 'error');
      } else {
        showSnackbar('Erreur lors du changement de statut', 'error');
      }
    } finally {
      setActionLoading(false);
    }
  };

  const handleSetMainBranch = async (id) => {
    if (!window.confirm('Définir cette succursale comme succursale principale ?')) return;
    
    setActionLoading(true);
    
    try {
      await api.patch(`/succursales/${id}/set_main_branch/`);
      
      await fetchSuccursales();
      showSnackbar('Succursale définie comme principale', 'success');
      
    } catch (err) {
      console.error('Erreur succursale principale:', err);
      
      if (err.response?.status === 401) {
        showSnackbar('Session expirée', 'error');
      } else {
        showSnackbar('Erreur lors du changement de succursale principale', 'error');
      }
    } finally {
      setActionLoading(false);
    }
  };

  const handleRefresh = () => {
    fetchSuccursales();
    // fetchEntreprises();
    fetchManagers();
    showSnackbar('Données actualisées', 'info');
  };

  const canCreateSuccursale = () => {
    if (!currentUser) return false;
    console.log('Permission création - Rôle:', currentUser.role);
    return currentUser.role === 'super_admin' || 
           currentUser.role === 'proprietaire' || 
           currentUser.role === 'manager';
  };

  const canEditSuccursale = (succursale) => {
    if (!currentUser) return false;
    if (currentUser.role === 'super_admin') return true;
    if (currentUser.role === 'proprietaire' && currentUser.entreprise === succursale.entreprise) return true;
    if (currentUser.role === 'manager' && succursale.manager === currentUser.id) return true;
    return false;
  };

  const canDeleteSuccursale = (succursale) => {
    if (!currentUser) return false;
    if (succursale.is_main_branch) return false;
    if (currentUser.role === 'super_admin') return true;
    if (currentUser.role === 'proprietaire' && currentUser.entreprise === succursale.entreprise) return true;
    return false;
  };

  const safeSuccursales = Array.isArray(succursales) ? succursales : [];

  const filteredSuccursales = safeSuccursales.filter(succursale => {
    if (!succursale) return false;
    
    const searchLower = search.toLowerCase();
    const entrepriseNom = succursale.entreprise_details?.nom || '';
    const managerNom = succursale.manager_details?.username || '';
    
    return (
      (succursale.nom?.toLowerCase() || '').includes(searchLower) ||
      (succursale.code?.toLowerCase() || '').includes(searchLower) ||
      (succursale.adresse?.toLowerCase() || '').includes(searchLower) ||
      entrepriseNom.toLowerCase().includes(searchLower) ||
      managerNom.toLowerCase().includes(searchLower)
    );
  });

  const paginatedSuccursales = filteredSuccursales.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      return format(parseISO(dateString), 'dd/MM/yyyy', { locale: fr });
    } catch (e) {
      return dateString;
    }
  };

  const getEntrepriseNom = (succursale) => {
    if (succursale.entreprise_details?.nom) return succursale.entreprise_details.nom;
    return 'N/A';
  };

  // const getManagerNom = (succursale) => {
  //   if (succursale.manager_details?.username) return succursale.manager_details.username;
  //   if (succursale.manager_details?.first_name && succursale.manager_details?.last_name) {
  //     return `${succursale.manager_details.first_name} ${succursale.manager_details.last_name}`;
  //   }
  //   return 'Non assigné';
  // };
  const getManagerNom = (succursale) => {
    // Vérifier d'abord si manager_details existe
    if (succursale.manager_details) {
        if (succursale.manager_details.username) 
            return succursale.manager_details.username;
        if (succursale.manager_details.first_name && succursale.manager_details.last_name) 
            return `${succursale.manager_details.first_name} ${succursale.manager_details.last_name}`;
        if (succursale.manager_details.email) 
            return succursale.manager_details.email;
        if (succursale.manager_details.nom) 
            return succursale.manager_details.nom;
    }
    
    // Vérifier si manager_name est présent (parfois utilisé)
    if (succursale.manager_name) 
        return succursale.manager_name;
    
    // Vérifier si manager est un objet avec des détails
    if (succursale.manager && typeof succursale.manager === 'object') {
        if (succursale.manager.username) 
            return succursale.manager.username;
        if (succursale.manager.first_name && succursale.manager.last_name) 
            return `${succursale.manager.first_name} ${succursale.manager.last_name}`;
        if (succursale.manager.email) 
            return succursale.manager.email;
        if (succursale.manager.nom) 
            return succursale.manager.nom;
    }
    
    // Si on a un ID de manager mais pas de détails
    if (succursale.manager && typeof succursale.manager === 'number') {
        // Chercher dans la liste des managers chargés
        const foundManager = managers.find(m => m.id === succursale.manager);
        if (foundManager) {
            return foundManager.first_name && foundManager.last_name
                ? `${foundManager.first_name} ${foundManager.last_name}`
                : foundManager.username || foundManager.email || `Manager #${succursale.manager}`;
        }
        return `Manager #${succursale.manager}`;
    }
    
    // Si on a manager_name dans les props directes
    if (succursale.manager_name) {
        return succursale.manager_name;
    }
    
    return 'Non assigné';
};

  if (loading && !currentUser) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="400px">
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Chargement...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Card sx={{ p: 3, mb: 3, boxShadow: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Box>
            <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 1 }}>
              <BusinessIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
              Gestion des Succursales
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {filteredSuccursales.length} succursale(s) trouvée(s)
            </Typography>
          </Box>
          
          <Box display="flex" gap={2}>
            <Tooltip title="Actualiser les données">
              <Button
                variant="outlined"
                startIcon={<RefreshIcon />}
                onClick={handleRefresh}
                disabled={actionLoading || loading}
                sx={{ borderRadius: '8px' }}
              >
                Actualiser
              </Button>
            </Tooltip>
            
            {canCreateSuccursale() && (
              <Tooltip title="Ajouter une nouvelle succursale">
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog('add')}
                  disabled={actionLoading}
                  sx={{ borderRadius: '8px', bgcolor: 'primary.main', '&:hover': { bgcolor: 'primary.dark' } }}
                >
                  Nouvelle Succursale
                </Button>
              </Tooltip>
            )}
          </Box>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}

        <Box mb={3}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Rechercher par nom, code, adresse, entreprise ou manager..."
            value={search}
            onChange={handleSearch}
            disabled={actionLoading}
            sx={{ 
              borderRadius: '8px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px'
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: search && (
                <InputAdornment position="end">
                  <IconButton 
                    size="small" 
                    onClick={() => setSearch('')}
                    disabled={actionLoading}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Box>

        <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius: '8px' }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: 'primary.main' }}>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Code</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Nom</TableCell>
                {/* <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Entreprise</TableCell> */}
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Adresse</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Manager</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Statut</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Ouverture</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                    <Box display="flex" justifyContent="center" alignItems="center">
                      <CircularProgress size={24} sx={{ mr: 2 }} />
                      <Typography color="text.secondary">
                        Chargement des succursales...
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : paginatedSuccursales.length > 0 ? (
                paginatedSuccursales.map((succursale) => (
                  <TableRow 
                    key={succursale.id}
                    hover
                    sx={{ 
                      '&:hover': { bgcolor: 'action.hover' },
                      opacity: succursale.is_active ? 1 : 0.7
                    }}
                  >
                    <TableCell>
                      <Chip 
                        label={succursale.code || 'N/A'} 
                        size="small"
                        color="primary"
                        variant="outlined"
                        sx={{ fontWeight: 'medium' }}
                      />
                    </TableCell>
                    <TableCell>
                      <Box display="flex" alignItems="center">
                        {succursale.is_main_branch && (
                          <Tooltip title="Succursale principale">
                            <HomeIcon 
                              fontSize="small" 
                              sx={{ mr: 1, color: 'warning.main' }} 
                            />
                          </Tooltip>
                        )}
                        <Typography variant="body2" fontWeight="medium">
                          {succursale.nom}
                        </Typography>
                      </Box>
                    </TableCell>
                    {/* <TableCell>
                      <Typography variant="body2" color="text.secondary">
                        {getEntrepriseNom(succursale)}
                      </Typography>
                    </TableCell> */}
                    <TableCell>
                      <Box display="flex" alignItems="center">
                        <LocationIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
                        <Typography variant="body2">
                          {succursale.adresse || 'N/A'}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box display="flex" alignItems="center">
                        <PersonIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
                        <Typography variant="body2">
                          {getManagerNom(succursale)}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={canEditSuccursale(succursale) ? "Cliquer pour changer le statut" : "Statut"}>
                        <Chip
                          icon={succursale.is_active ? <ActiveIcon /> : <InactiveIcon />}
                          label={succursale.is_active ? 'Active' : 'Inactive'}
                          color={succursale.is_active ? 'success' : 'error'}
                          size="small"
                          variant="outlined"
                          onClick={canEditSuccursale(succursale) ? () => handleToggleStatus(succursale.id, succursale.is_active) : undefined}
                          sx={{ 
                            cursor: canEditSuccursale(succursale) ? 'pointer' : 'default',
                            fontWeight: 'medium'
                          }}
                          disabled={actionLoading || !canEditSuccursale(succursale)}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {formatDate(succursale.date_ouverture)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Box display="flex" gap={1}>
                        <Tooltip title="Voir détails">
                          <IconButton
                            size="small"
                            onClick={() => handleOpenDialog('view', succursale)}
                            color="info"
                            disabled={actionLoading}
                            sx={{ 
                              bgcolor: 'info.light', 
                              '&:hover': { bgcolor: 'info.main', color: 'white' },
                              '&:disabled': { bgcolor: 'action.disabledBackground' }
                            }}
                          >
                            <ViewIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        
                        {canEditSuccursale(succursale) && (
                          <Tooltip title="Modifier">
                            <IconButton
                              size="small"
                              onClick={() => handleOpenDialog('edit', succursale)}
                              color="primary"
                              disabled={actionLoading}
                              sx={{ 
                                bgcolor: 'primary.light', 
                                '&:hover': { bgcolor: 'primary.main', color: 'white' },
                                '&:disabled': { bgcolor: 'action.disabledBackground' }
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                        
                        {!succursale.is_main_branch && canEditSuccursale(succursale) && (
                          <Tooltip title="Définir comme principale">
                            <IconButton
                              size="small"
                              onClick={() => handleSetMainBranch(succursale.id)}
                              color="warning"
                              disabled={actionLoading}
                              sx={{ 
                                bgcolor: 'warning.light', 
                                '&:hover': { bgcolor: 'warning.main', color: 'white' },
                                '&:disabled': { bgcolor: 'action.disabledBackground' }
                              }}
                            >
                              <HomeIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                        
                        {canDeleteSuccursale(succursale) && (
                          <Tooltip title="Supprimer">
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(succursale.id)}
                              color="error"
                              disabled={actionLoading}
                              sx={{ 
                                bgcolor: 'error.light', 
                                '&:hover': { bgcolor: 'error.main', color: 'white' },
                                '&:disabled': { bgcolor: 'action.disabledBackground' }
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                    <Typography color="text.secondary">
                      {search ? 'Aucune succursale ne correspond à votre recherche' : 'Aucune succursale trouvée'}
                    </Typography>
                    {!loading && entreprises.length === 0 && (
                      <Typography variant="caption" display="block" color="error" sx={{ mt: 1 }}>
                        Impossible de charger la liste des entreprises
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          
          {filteredSuccursales.length > 0 && (
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredSuccursales.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Lignes par page:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} sur ${count}`
              }
              sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}
            />
          )}
        </Paper>
      </Card>

      {/* Dialog pour ajouter/modifier/voir */}
      <Dialog 
        open={openDialog} 
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: '12px' }
        }}
      >
        <DialogTitle sx={{ 
          bgcolor: 'primary.main', 
          color: 'white',
          borderTopLeftRadius: '12px',
          borderTopRightRadius: '12px'
        }}>
          <Box display="flex" alignItems="center">
            {dialogMode === 'add' ? <AddIcon sx={{ mr: 1 }} /> : 
             dialogMode === 'edit' ? <EditIcon sx={{ mr: 1 }} /> : 
             <ViewIcon sx={{ mr: 1 }} />}
            {dialogMode === 'add' ? 'Nouvelle Succursale' : 
             dialogMode === 'edit' ? 'Modifier la Succursale' : 
             'Détails de la Succursale'}
          </Box>
          
          {selectedSuccursale?.code && (
            <Typography variant="caption" sx={{ display: 'block', mt: 1, opacity: 0.9 }}>
              Code: {selectedSuccursale.code}
            </Typography>
          )}
        </DialogTitle>
        
        <DialogContent sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            {/* <Grid item xs={12} sm={6}>
              <FormControl 
                fullWidth 
                error={!!formErrors.entreprise}
                disabled={dialogMode === 'view' || actionLoading || (currentUser && currentUser.role === 'super_admin' ? false : true)}
                sx={{ mt: 1 }}
              >
                <InputLabel>Entreprise *</InputLabel>
                <Select
                  name="entreprise"
                  value={formData.entreprise}
                  onChange={handleInputChange}
                  label="Entreprise *"
                >
                  {entreprises.map((entreprise) => (
                    <MenuItem key={entreprise.id} value={entreprise.id}>
                      {entreprise.nom} 
                      {entreprise.module_actif && ` (${entreprise.module_actif})`}
                    </MenuItem>
                  ))}
                </Select>
                {formErrors.entreprise && (
                  <Typography variant="caption" color="error">
                    {formErrors.entreprise}
                  </Typography>
                )}
              </FormControl>
            </Grid> */}
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nom *"
                name="nom"
                value={formData.nom}
                onChange={handleInputChange}
                error={!!formErrors.nom}
                helperText={formErrors.nom}
                disabled={dialogMode === 'view' || actionLoading}
                sx={{ mt: 1 }}
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Adresse *"
                name="adresse"
                value={formData.adresse}
                onChange={handleInputChange}
                multiline
                rows={2}
                error={!!formErrors.adresse}
                helperText={formErrors.adresse}
                disabled={dialogMode === 'view' || actionLoading}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Téléphone"
                name="telephone"
                value={formData.telephone}
                onChange={handleInputChange}
                error={!!formErrors.telephone}
                helperText={formErrors.telephone}
                disabled={dialogMode === 'view' || actionLoading}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PhoneIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                error={!!formErrors.email}
                helperText={formErrors.email}
                disabled={dialogMode === 'view' || actionLoading}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <FormControl 
                fullWidth 
                disabled={dialogMode === 'view' || actionLoading}
                error={!!formErrors.manager}
              >
                <InputLabel>Manager</InputLabel>
                <Select
                  name="manager"
                  value={formData.manager}
                  onChange={handleInputChange}
                  label="Manager"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300
                      }
                    }
                  }}
                >
                  <MenuItem value="">
                    <em>Aucun manager</em>
                  </MenuItem>
                  
                  {loadingManagers ? (
                    <MenuItem disabled>
                      <Box display="flex" alignItems="center">
                        <CircularProgress size={16} sx={{ mr: 1 }} />
                        <Typography variant="body2" color="text.secondary">
                          Chargement des managers...
                        </Typography>
                      </Box>
                    </MenuItem>
                  ) : managers.length === 0 ? (
                    <MenuItem disabled>
                      <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                        Aucun manager disponible
                      </Typography>
                    </MenuItem>
                  ) : (
                    managers.map((manager) => (
                      <MenuItem key={manager.id} value={manager.id}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          <Typography variant="body2">
                            {manager.first_name && manager.last_name 
                              ? `${manager.first_name} ${manager.last_name}`
                              : manager.username || `Manager ${manager.id}`}
                          </Typography>
                          {/* <Typography variant="caption" color="text.secondary">
                            {manager.role ? `Rôle: ${manager.role}` : ''}
                            {manager.email && manager.role ? ' • ' : ''}
                            {manager.email ? manager.email : ''}
                          </Typography> */}
                        </Box>
                      </MenuItem>
                    ))
                  )}
                </Select>
                
                {!loadingManagers && managers.length > 0 && (
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                    {managers.length} manager(s) disponible(s)
                  </Typography>
                )}
                
                {formErrors.manager && (
                  <Typography variant="caption" color="error">
                    {formErrors.manager}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Date d'ouverture *"
                name="date_ouverture"
                type="date"
                value={formData.date_ouverture}
                onChange={handleInputChange}
                error={!!formErrors.date_ouverture}
                helperText={formErrors.date_ouverture}
                disabled={dialogMode === 'view' || actionLoading}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Date de fermeture"
                name="date_fermeture"
                type="date"
                value={formData.date_fermeture}
                onChange={handleInputChange}
                disabled={dialogMode === 'view' || actionLoading}
                InputLabelProps={{ shrink: true }}
                helperText="Optionnel - Laisser vide si toujours active"
              />
            </Grid>
            
            {dialogMode !== 'view' && (
              <>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.is_active}
                        onChange={handleSwitchChange}
                        name="is_active"
                        color="primary"
                        disabled={actionLoading}
                      />
                    }
                    label="Succursale active"
                  />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.is_main_branch}
                        onChange={handleSwitchChange}
                        name="is_main_branch"
                        color="warning"
                        disabled={actionLoading}
                      />
                    }
                    label="Succursale principale"
                  />
                </Grid>
              </>
            )}
            
            {/* Display API errors */}
            {Object.keys(formErrors).filter(key => key !== 'non_field_errors').length > 0 && (
              <Grid item xs={12}>
                <Alert severity="error" sx={{ mt: 2 }}>
                  <Typography variant="subtitle2">Erreurs de validation :</Typography>
                  <ul style={{ margin: 0, paddingLeft: '20px' }}>
                    {Object.entries(formErrors)
                      .filter(([key]) => key !== 'non_field_errors')
                      .map(([key, value]) => (
                        <li key={key}>
                          <strong>{key}</strong>: {value}
                        </li>
                      ))
                    }
                  </ul>
                </Alert>
              </Grid>
            )}
            
            {formErrors.non_field_errors && (
              <Grid item xs={12}>
                <Alert severity="error" sx={{ mt: 2 }}>
                  {Array.isArray(formErrors.non_field_errors) 
                    ? formErrors.non_field_errors.join(', ')
                    : formErrors.non_field_errors}
                </Alert>
              </Grid>
            )}
            
            {dialogMode === 'view' && selectedSuccursale && (
              <Grid item xs={12}>
                <Paper variant="outlined" sx={{ p: 2, mt: 2, bgcolor: 'grey.50' }}>
                  <Typography variant="subtitle2" gutterBottom fontWeight="bold">
                    Informations supplémentaires:
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2">
                        <strong>Code:</strong> {selectedSuccursale.code || 'N/A'}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2">
                        <strong>Créé le:</strong> {formatDate(selectedSuccursale.created_at)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2">
                        <strong>Manager:</strong> {getManagerNom(selectedSuccursale)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2">
                        <strong>Dernière modification:</strong> {formatDate(selectedSuccursale.updated_at)}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2">
                        <strong>Statut complet:</strong> {selectedSuccursale.is_active ? 'Active' : 'Inactive'} • 
                        {selectedSuccursale.is_main_branch ? ' Principale' : ' Secondaire'}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        
        <DialogActions sx={{ p: 2, borderTop: '1px solid rgba(0, 0, 0, 0.12)' }}>
          <Button 
            onClick={handleCloseDialog} 
            disabled={actionLoading}
            variant="outlined"
            sx={{ borderRadius: '8px' }}
          >
            {dialogMode === 'view' ? 'Fermer' : 'Annuler'}
          </Button>
          
          {dialogMode !== 'view' && (
            <Button 
              onClick={handleSubmit} 
              variant="contained"
              disabled={actionLoading}
              startIcon={actionLoading ? <CircularProgress size={20} /> : null}
              sx={{ borderRadius: '8px' }}
            >
              {dialogMode === 'add' ? 'Créer' : 'Enregistrer'}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Snackbar pour les notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleSnackbarClose} 
          severity={snackbarSeverity} 
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Succursale;